var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, createContext } from 'react';
import { Modal } from '@one-thd/sui-atomic-components';
var ModalContext = createContext(null);
var ModalProvider = function (_a) {
    var children = _a.children;
    var initialState = {
        ContentComponent: null,
        componentProps: {},
        modalProps: {},
        isOpened: false,
    };
    var _b = __read(useState(initialState), 2), modalState = _b[0], setModalState = _b[1];
    /**
     * openModal function.
     *
     * @param {React.FC} ContentComponent - a modal content component
     * @param {any} [componentProps={}] - a modal content component (ContentComponent) props
     * @param {IModalProps} [modalProps={}] - a stencil modal props
     *
     * @example
     *     const BasicModalContent = ({title}: string) => <p>This is a basic modal's content. {title}</p>;
     *     // Update  stencil modal props
     *     const modalProps = { size: 'sm' };
     *
     *     openModal(BasicModalContent, { title: 'Modal Title' }, modalProps);
     */
    var openModal = function (ContentComponent, componentProps, modalProps) {
        if (componentProps === void 0) { componentProps = {}; }
        if (modalProps === void 0) { modalProps = {}; }
        setModalState({
            ContentComponent: ContentComponent,
            componentProps: componentProps,
            modalProps: modalProps,
            isOpened: true,
        });
    };
    /**
     * hideModal function for hiding (closing) opened modal
     *
     */
    var hideModal = function () {
        setModalState({
            ContentComponent: null,
            componentProps: {},
            modalProps: {},
            isOpened: false,
        });
    };
    var setComponentProps = function (componentProps) {
        setModalState(function (prevModalState) { return (__assign(__assign({}, prevModalState), { componentProps: __assign(__assign({}, prevModalState.componentProps), componentProps) })); });
    };
    return (React.createElement(ModalContext.Provider, { value: {
            openModal: openModal,
            hideModal: hideModal,
            isOpened: modalState.isOpened,
            setComponentProps: setComponentProps,
        } },
        React.createElement(Modal, __assign({ open: modalState.isOpened, onClose: hideModal }, modalState.modalProps), modalState.ContentComponent && (React.createElement(modalState.ContentComponent, __assign({ hideModal: hideModal }, modalState.componentProps)))),
        children));
};
export { ModalProvider, ModalContext };
